var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-icon",on:{"click":_vm.click}},[(!_vm.isFullscreen)?_c('i',{staticClass:"iconfont icon-fullscreen"}):_c('i',{staticClass:"iconfont icon-fullscreen"})])
}
var staticRenderFns = []

export { render, staticRenderFns }